/**
 * Outbound provider credentials — /api/ticketing/providers.
 *
 * Uses the CONFIGURED client (`dashboardApi`), not bare axios: only that
 * instance attaches the Bearer token and the active-country header, and only
 * its response interceptor reaches the silent-refresh / session-expired path.
 * See __tests__/noBareAxiosInActions.test.js for what bare axios costs.
 *
 * The plaintext secret travels IN on create/rotate and never comes back OUT —
 * every response carries a `****abcd` hint instead.
 */
import { dashboardApi as API } from "./index.js";

const BASE = "/api/ticketing/providers";

export const apiProviderCredentials = (params = {}) => API.get(BASE, { params });
export const apiCreateProviderCredential = (body) => API.post(BASE, body);
export const apiUpdateProviderCredential = (id, body) => API.put(`${BASE}/${id}`, body);
export const apiRotateProviderCredential = (id, body) => API.post(`${BASE}/${id}/rotate`, body);
export const apiDisableProviderCredential = (id) => API.post(`${BASE}/${id}/disable`, {});
export const apiTestProviderCredential = (id, body) => API.post(`${BASE}/${id}/test`, body);

export default apiProviderCredentials;
